import {
  ArrayReferenceFilterConfig,
  BooleanFilterConfig,
  GeoRangeFilterConfig,
  IArrayReferenceFilter,
  IBooleanFilter,
  IFilter,
  IFilterConfig,
  IGeoRangeFilter,
  INumberFilter,
  ISelection,
  IShape,
  ISingleReferenceFilter,
  NumberFilterConfig,
  SingleReferenceFilterConfig,
} from 'pbc.types';

import { IRolle, IStandort } from 'fa-kt.types';
import { IMitarbeiterResponse } from '.';

export interface IMitarbeiterQueryFilter extends IFilter<IMitarbeiterResponse> {
  'mitarbeiter.addresse'?: IGeoRangeFilter;
  'mitarbeiter.standort'?: ISingleReferenceFilter<IStandort>;
  'mitarbeiter.rollen'?: IArrayReferenceFilter<IRolle>;
  'mitarbeiter.stundenlohn'?: INumberFilter;
  'mitarbeiter.inaktiv'?: IBooleanFilter;
  'mitarbeiter.isAdmin'?: IBooleanFilter;
  'rollen.isAdmin'?: IBooleanFilter;
}

export const MitarbeiterQueryFilterConfig: IFilterConfig<IMitarbeiterResponse> = [
  GeoRangeFilterConfig('mitarbeiter.addresse', 'PERSONEN.Models.MITARBEITER.Propertys.ADDRESSE.title'),
  SingleReferenceFilterConfig<IStandort>('mitarbeiter.standort', 'PERSONEN.Models.MITARBEITER.Propertys.STANDORT.title'),
  ArrayReferenceFilterConfig<IRolle>('mitarbeiter.rollen', 'PERSONEN.Models.MITARBEITER.Propertys.ROLLEN.title'),
  NumberFilterConfig('mitarbeiter.stundenlohn', 'PERSONEN.Models.MITARBEITER.Propertys.STUNDENLOHN.title'),
  BooleanFilterConfig('mitarbeiter.inaktiv', 'PERSONEN.Models.MITARBEITER.Propertys.INAKTIV.title'),
  BooleanFilterConfig('mitarbeiter.isAdmin', 'Administrator'),
  BooleanFilterConfig('rollen.isAdmin', 'Administrator'),
];

export interface IMitarbeiterQueryShapes extends IShape {
  'mitarbeiter.standort': ISelection[];
  'mitarbeiter.rollen': ISelection[];
}

export type IMitarbeiterQueryField =
  | 'mitarbeiter.id'
  | 'mitarbeiter.email'
  | 'mitarbeiter.anzeigename'
  | 'mitarbeiter.bild'
  | 'mitarbeiter.addresse'
  | 'mitarbeiter.vorname'
  | 'mitarbeiter.nachname'
  | 'mitarbeiter.telefon'
  | 'mitarbeiter.standort'
  | 'mitarbeiter.rollen'
  | 'mitarbeiter.stundenlohn'
  | 'mitarbeiter.inaktiv'
  | 'rollen.id'
  | 'rollen.name'
  | 'rollen.beschreibung'
  | 'rollen.finanzen'
  | '';
